<template>
  <b-card no-body>
    <div class="d-flex justify-content-between align-items-center p-3">
      <div class="d-flex align-items-center">
        <div class="state-icon" :class="submitalLocked ? 'state-icon--locked' : 'state-icon--unlocked'">
          <font-awesome-icon :icon="['fas', submitalLocked ? 'lock-alt' : 'lock-open-alt']" />
        </div>
        <div class="ml-3">
          <div class="fs-15 font-weight-bold">Estado del submital</div>
          <div class="fs-13 text-muted">
            {{ submitalLocked
              ? 'Solo lectura'
              : 'El submital permite la edición' }}
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center flex-shrink-0">
        <span class="state-pill mr-3" :class="submitalLocked ? 'state-pill--locked' : 'state-pill--unlocked'">
          <span class="state-dot"></span>{{ submitalLocked ? 'Bloqueado' : 'Desbloqueado' }}
        </span>
        <b-button :variant="submitalLocked ? 'primary' : 'warning'" size="sm" :disabled="processing" @click="openModal">
          <font-awesome-icon :icon="['fas', submitalLocked ? 'lock-open-alt' : 'lock-alt']" fixed-width />
          <span class="fs-14">{{ submitalLocked ? 'Desbloquear' : 'Bloquear' }}</span>
        </b-button>
      </div>
    </div>

    <b-row no-gutters class="border-top">
      <b-col class="p-3">
        <div class="fs-14 text-muted">Creado</div>
        <div class="fs-13">{{ submital.created_at | formatDateTime }}</div>
      </b-col>
      <b-col class="p-3 border-left">
        <div class="fs-14 text-muted">Última edición</div>
        <div class="fs-13">{{ configurable.updated_at | formatDateTime }}</div>
      </b-col>
    </b-row>

    <!-- Lock Modal -->
    <SubmitalLockModal
      :show="showModal"
      @close="showModal = false"
    />
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'

import Button from '../../shared/Button'
import Modal from '../../shared/Modal'
import SubmitalLockModal from './SubmitalLockModal'

export default {
  name: 'SubmitalLockCard',
  components: { Button, Modal, SubmitalLockModal },
  props: {
    submital: { type: Object, required: true },
    configurable: { type: Object, required: true }
  },
  data () {
    return {
      showModal: false,
      form: {
        description: ''
      },
      processing: false,
      submitted: false,
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters(['submitalLocked']),
  },
  methods: {
    openModal () {
      this.showModal = true
    }
  }
}
</script>

<style scoped>
.state-icon {
  width: 2.625rem;
  height: 2.625rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 18px;
}
.state-icon--unlocked { background: #bbdcc4; color: #043b11; }
.state-icon--locked   { background: #fd5252; color: #ffffff; }

.state-pill {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 20px;
  white-space: nowrap;
}
.state-pill--unlocked { background: #bbdcc4; color: #043b11; }
.state-pill--locked   { background: #fd5252; color: #ffffff; }

.state-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
  margin-right: 6px;
}
</style>
